import QuickPurchaseModal from './QuickPurchaseModal';

export default QuickPurchaseModal;
